module.exports = __webpack_public_path__ + "static/img/uav_tips.fdda19c0.png";